import type { PDFFoxitRect } from "../../helper-types";
import type { PDFViewCtrl } from "../../loaders/foxit-pdf-view-ctrl";
import type { JrWorkerConfig } from "../types";

import { DEFAULT_SCALE, MAX_SCALE, MIN_SCALE } from "./const";

export const createPdfViewer = (
  pdfViewCtrl: typeof PDFViewCtrl,
  jrConfig: JrWorkerConfig,
  libPath?: string,
) => {
  const pdfViewer = new pdfViewCtrl.PDFViewer({
    defaultScale: DEFAULT_SCALE,
    minScale: MIN_SCALE,
    maxScale: MAX_SCALE,
    libPath,
    jr: jrConfig,
    messageSyncServiceWorker: {
      options: {
        scope: "/",
      },
    },
    StateHandlers: [],
    viewerUI: new (class ViewerUI extends pdfViewCtrl.viewerui.TinyViewerUI {
      constructor() {
        super();
      }

      createContextMenu(): PDFViewCtrl.viewerui.IContextMenu | undefined {
        return undefined;
      }

      createTextSelectionTooltip(
        _pageRender: PDFViewCtrl.renderers.PDFPageRender,
      ) {
        return new (class TextSelectionTooltip
          extends pdfViewCtrl.viewerui.IFloatingTooltip
        {
          showAt(
            _x: number,
            _y: number,
            _text: string,
            _rects: PDFFoxitRect[],
          ): void {
            return;
          }
        })();
      }
    })(),
    customs: {
      ScrollWrap: pdfViewCtrl.DivScrollWrap,

      getDocPermissions: function () {
        const userPermissions = pdfViewCtrl.PDF.constant.User_Permissions;

        return (
          // rotating pages
          userPermissions.assemble |
          // adding highlight annotations
          userPermissions.annotForm |
          // modifying annotations
          userPermissions.fillForm | // copying text
          userPermissions.extract
        );
      },

      getAnnotPermissions: () => {
        // See ANNOTATION_PERMISSION enum for reference on possible permissions.
        // https://webviewer-demo.foxit.com/docs/API_Reference/html/group___viewer_constants.html#ga541bebd5ef836b569f48512d8c778f15
        // We don't want to add "editable" permission here as it causes reply dialog to be displayed when double-clicking on an annotation.
        return Promise.resolve([]);
      },
    },
  });

  pdfViewer.grantQueryLocalFontsPermission("denied");

  return pdfViewer;
};
